class queueHelper {
  static getColorByStatus (status) {
    switch (parseInt(status)) {
    case 1:
      return 'busy'
    case 4:
      return 'logout'
    case 8:
      return 'ringing'
    case -1:
      return 'logout'
    case 11:
      return 'rest'
    case 21:
      return 'lunch'
    case 31:
      return 'after'
    case 12:
      return 'consultation-available'
    case 22:
      return 'consultation-available'
    case 32:
      return 'consultation-available'
    default:
      return 'default' // 0, 12, 22, 32
    }
  }
}

export default queueHelper
